import get from 'lodash/get'
import merge from 'lodash/merge'
let hash = {}

const stringWidth = ({ text = '', fontSize, context }) => {
  let w = get(hash, `[${fontSize}][${text.length}]`)

  if (typeof w !== 'undefined') {
    return w
  }

  context.font = `normal ${fontSize}px`
  w = context.measureText(text).width
  hash = merge({}, hash, { [fontSize]: { [text.length]: w } })
  return w
}

export default stringWidth
